import React, { useContext } from 'react';

import { Modal } from 'app/design-system/components/Modal';
import { useTranslation } from 'app/lang';

import { RegContext } from '../../context';
import { getHeaderContent } from '../../utils/signing-helpers';

export const Header = () => {
  const { t } = useTranslation();
  const { regData } = useContext(RegContext);
  const CONTENT = t(getHeaderContent(regData));

  return (
    <Modal.Header data-test="Modal-Signing-header">
      {CONTENT}
    </Modal.Header>
  );
};
